// AssigneePopup.jsx
import React, {useState} from 'react';

const AssigneePopup = ({
  users,
  selectedAssignees,
  onSelect,
  getInitials,
  getRandomColor,
  loading,
}) => {
  const [userToRemove, setUserToRemove] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleUserClick = (user, isSelected) => {
    if (loading) return;
    if (isSelected) {
      setUserToRemove(user);
      setShowConfirmDialog(true);
    } else {
      onSelect(user);
    }
  };

  const handleConfirmRemove = () => {
    if (userToRemove) {
      onSelect(userToRemove);
      setShowConfirmDialog(false);
      setUserToRemove(null);
    }
  };

  const handleCancelRemove = () => {
    setShowConfirmDialog(false);
    setUserToRemove(null);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '350px' }}>
      <div style={{ padding: '12px', borderBottom: '1px solid #eee', fontWeight: 'bold', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Select Assignees</span>
        <span style={{ fontSize: '11px', color: '#666', backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: '12px' }}>
          {selectedAssignees.length} assigned
        </span>
      </div>

      <div style={{ maxHeight: '200px', overflowY: 'auto', flex: 1 }}>
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }} /> Loading users...
          </div>
        ) : users && users.length > 0 ? (
          users.map(user => {
            const isSelected = selectedAssignees.some(a => a.id === user.id);
            return (
              <div
                key={user.id}
                onClick={() => handleUserClick(user, isSelected)}
                style={{
                  padding: '10px 12px', cursor: loading ? 'not-allowed' : 'pointer',
                  backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                  borderBottom: '1px solid #f5f5f5', display: 'flex', alignItems: 'center', gap: '10px',
                  transition: 'background-color 0.2s ease',
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = isSelected ? '#e3f2fd' : '#f5f5f5'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = isSelected ? '#e3f2fd' : 'transparent'}
              >
                <div style={{
                  width: '30px', height: '30px', borderRadius: '50%', backgroundColor: user.color || getRandomColor(user.id),
                  color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '12px', flexShrink: 0,
                }}>
                  {getInitials(user.name)}
                </div>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{user.name}</span>
                {isSelected ? (
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    <i className="fas fa-check" style={{ color: '#1976d2' }} />
                    <i className="fas fa-minus-circle" style={{ color: '#dc3545', fontSize: '14px' }} />
                  </div>
                ) : (
                  <i className="fas fa-plus-circle" style={{ color: '#28a745' }} title="Click to assign" />
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
            <i className="fas fa-users" style={{ marginRight: '8px', fontSize: '24px', opacity: 0.5 }} />
            <div style={{ marginTop: '8px' }}>No users available</div>
          </div>
        )}
      </div>

      {showConfirmDialog && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)',
          borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3,
        }}>
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '16px', width: '200px', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px', color: '#333' }}>Remove Assignee?</div>
            <div style={{ fontSize: '13px', marginBottom: '16px', color: '#666' }}>
              Are you sure you want to remove <strong>{userToRemove?.name}</strong> from this task?
            </div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={handleCancelRemove} style={{ padding: '6px 12px', border: '1px solid #ddd', backgroundColor: 'white', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', color: '#666' }}>
                Cancel
              </button>
              <button onClick={handleConfirmRemove} style={{ padding: '6px 12px', border: 'none', backgroundColor: '#dc3545', color: 'white', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}>
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssigneePopup;